module.exports = __webpack_public_path__ + "img/analyze-and-win.ce0edd3f.svg";